import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthGuardService } from '../../services/auth-guard.service';
import { CognitoServiceService } from '../../services/cognito-service.service';
import { HttpService } from '../../services/http.service';
import { FormDefinitionsService } from '../../services/forms/form-definitions.service';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupConsentPinComponent } from '../popups/popup-consent-pin/popup-consent-pin.component';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {
  heading: string;
  options: any;
  signupData: any;
  showToast: boolean;
  signupForm: any;
  loginForm: any;
  vrificationPopupData: DynamicItem;
  showVerificationPopupFlag: boolean;
  cognitoUser: any;
  MAFCallabbck: any;

  constructor(private router: Router,
    private formDefinitionsService: FormDefinitionsService,
    private auth: AuthGuardService,
    private cognito: CognitoServiceService,
    private utils: UtilitiesService,
    private http: HttpService) {
      this.utils.removeItemFromLocalStorage('usersession');
    this.router.events.subscribe((res) => {
      var currentRoute: string = this.router.url;
      // Form heading based on current route
      if (currentRoute == '/signup') {
        this.heading = "SIGN UP";
      } else if (currentRoute == '/login') {
        this.heading = "LOGIN"
      }
    })
  }

  ngOnInit() {
    var that = this;

    this.signupForm = this.formDefinitionsService.signupForm;
    
    this.loginForm = this.formDefinitionsService.loginForm;

    // If user is already logged in navigating him to dashboard
    if (this.cognito.getAuthenticatedUser()) {
      console.log(" cheching user details")
      that.router.navigate(['/dashboard']);
    }else{
      console.log(" go to login page..");
      //that.router.navigate(['/login']);
    }
  }

  /**
   * Checks the user existance with email in cognito userpool
   * @param form 
   */
  checkEmailExistance(event) {
    let form = event.formData;
    var data = {
      email: form.controls.email.value,
    }
    this.cognito.checkUserEmailExistance(data, (signinData) => {
      this.moveToVUACreation(form.value);
      form.reset();
    })
  }

  moveToVUACreation(form) {
    localStorage.setItem('signUpDetails', JSON.stringify(form));
    this.router.navigate(['/vua-creation']);
  }


  /**
   * @desc To login user
   * @param  {object} form
   */
  loginUser(event) {
    let form = event.formData;
    if (form.valid) {
      var data = {
        userName: form.controls.vua.value,
        password: form.controls.password.value
      }
      this.cognito.signin(data, (signinData) => { // Successful signin callback
        // successful signin
        form.reset();
        this.dashboardRedirection();
      }, (signUpData) => { // Code confirmation callback
        //user not confirmed case
        this.signupData = signUpData;
        this.showPopup('confirm');
      }, (MFA, user, callback) => { // MFA callback
        this.MAFCallabbck = callback;
        this.signupData = MFA;
        this.cognitoUser = user;
        //MFA need, enter OTP
        this.showPopup('MFA');
      })
    }
  }

  dashboardRedirection(){
    this.router.navigate(['/dashboard']);
    var self = this;
    this.options = {
      type: 'get',
      url: 'dashboard',
      includeUserSession: true,
      isDeveloper:true
    }
    this.http.makeHttpRequest(this.options).subscribe(res => {
      if (res['bankAccounts']) {
        if (res['bankAccounts'].length > 0) {
          self.router.navigate(['/dashboard']);
        } else {
          localStorage.setItem('newUser', 'true');
          self.router.navigate(["/account-list"]);
        }
      }
    },error=>{
      console.log(error," checking screen")
    });
  }

  showPopup(type) {
    let popuptext: any = {
      body: "Please Enter confirmation Code sent to mobile to Confirm",
      heading: "Account Confirmation"
    }

    if(type === 'MFA') {
      popuptext.successCallback = this.MFAConfirmation.bind(this);
    } else {
      popuptext.successCallback = this.verificationConfirm.bind(this);
    }
    popuptext.cancelCallback = this.closePopup.bind(this);

    this.vrificationPopupData = new DynamicItem(PopupConsentPinComponent, popuptext);
    this.showVerificationPopupFlag = true;
  }

  verificationConfirm(pin) {
    this.cognito.verify({ userName: this.signupData.userName }, pin, () => {
        this.closePopup();
        this.router.navigate(['/login']);
    });
  }

  MFAConfirmation(pin) {
    // this.cognito.MFAAuthentication({ userName: this.signupData.userName }, this.cognitoUser, pin, () => {
    //   this.closePopup();
    //   this.MAFCallabbck();
    // });
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    this.showVerificationPopupFlag = false;
  }

}
